<template>
    <div class="qr-code-wrapper" style="line-height: 0">
        <vue-qrcode ref="canvas" :value="value" type="image/png" :options="options" @ready="onReady" />
    </div>
</template>

<script>
import Colors from '@/helpers/colors'
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
    props: {
        value: {required: true},
        width: {},
        color: {},
    },
    components: {VueQrcode},
    data(){
        return {
            defaultColor: Colors.primary,
        }
    },
    computed: {
        computedColor(){
            return this.color || this.defaultColor;
        },
        options(){
            return {
                color: {dark: this.computedColor, light: '#ffffff'},
                width: this.width || 160,
                errorCorrectionLevel: 'Q',
            }
        }
    },
    methods: {

        onReady(canvas) {
            const context = canvas.getContext('2d');
            const image = new Image();

            window.console.log('test');

            image.src = '/img/icon.png';
            image.crossorigin = 'anonymous';
            image.onload = () => {
                const coverage = 0.15;
                const width = Math.round(canvas.width * coverage);
                const x = (canvas.width - width) / 2;

                this.drawImage(context, image, x, x, width, width);
            };
        },

        drawImage(context, image, x, y, width, height, radius = 4) {
            context.shadowOffsetX = 0;
            context.shadowOffsetY = 2;
            context.shadowBlur = 4;
            context.shadowColor = '#00000040';
            context.lineWidth = 8;
            context.beginPath();
            context.moveTo(x + radius, y);
            context.arcTo(x + width, y, x + width, y + height, radius);
            context.arcTo(x + width, y + height, x, y + height, radius);
            context.arcTo(x, y + height, x, y, radius);
            context.arcTo(x, y, x + width, y, radius);
            context.closePath();
            context.strokeStyle = '#fff';
            context.stroke();
            context.clip();
            context.fillStyle = '#fff';
            context.fillRect(x, x, width, height);
            context.drawImage(image, x, x, width, height);
        },
    },
    mounted(){
        window.setTimeout(()=>{
            this.onReady(this.$refs.canvas.$el);
        }, 200)
    }
}
</script>

<style lang="scss" scoped>

</style>
